// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "photos-" + chunkId + ".js?v=" + {"vendors-node_modules_leaflet-defaulticon-compatibility_src_Icon_Default_compatibility_js-node-a43fe3":"6836415b4e72c014489d","src_views_PhotosTab_vue":"769497a7ef1f1482a3ec"}[chunkId] + "";
};